import axios from 'axios';
import makeToken from '@/services/util/makeToken';
import storage from '@/services/util/sessionStorage';
import ToastMessage from '@/services/util/alertService';
import makeAuthPassport from './resources/makeAuthPassportHttp';

let isRefreshing = false;
export const urlBase = process.env.VUE_APP_BASE_URL_API;
export const prefixBase = process.env.VUE_APP_PREFIX_URL_API;
export const urlAuth = process.env.VUE_APP_URL_AUTH;

const clientHttp = axios.create({
  baseURL: urlBase,
});

const authPassport = makeAuthPassport(clientHttp);
const tokenService = makeToken(storage, authPassport);

const intercepRequest = (config) => {
  const configAxios = config;
  configAxios.headers.post['Content-Type'] = 'multipart/form-data';
  const token = tokenService.getTokenAuthorization();
  if (token !== null) {
    configAxios.headers.common.Authorization = token;
  }
  return configAxios;
};

const intercepRequestError = (error) => Promise.reject(error);

const intercepResponse = (response) => response;

const intercepResponseError = (error) => {
  if (error.response != null) {
    // Token expirado ou inválido
    if (error.response.status === 401) {
      if (!isRefreshing) {
        isRefreshing = true;
        const originalRequest = error.config;
        tokenService
          .refreshToken()
          .then(() => {
            isRefreshing = false;
            return new Promise((resolve) => {
              const token = tokenService.getTokenAuthorization();
              originalRequest.headers.Authorization = token;
              resolve(axios(originalRequest));
            });
          })
          .catch(() => {
            tokenService.setToken(null);
            window.location.replace(`${urlAuth}`);
          });
      }
    } else if (error.response.status === 403) {
      ToastMessage.notPermission();
    } else {
      return Promise.reject(error);
    }
  } else {
    return Promise.reject(error);
  }
  return Promise.reject(error);
};

clientHttp.interceptors.request.use(intercepRequest, intercepRequestError);
clientHttp.interceptors.response.use(intercepResponse, intercepResponseError);

export default clientHttp;
